import { useEffect } from 'react'
import { HOME_PRODUCT_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'

/**
 * Keep `homeProduct` aligned with deep-linked home routes.
 * @param {object} m
 */
export function useSyncHomeProductFromPath(m) {
  const { activePrimaryKey, location, setHomeProduct } = m
  const pathname = location.pathname

  useEffect(() => {
    if (activePrimaryKey !== 'home') return
    if (pathname === PATHS.DO_VOICE) {
      setHomeProduct(HOME_PRODUCT_KEYS.VOICE)
      return
    }
    if (pathname === PATHS.BUILD) {
      setHomeProduct(HOME_PRODUCT_KEYS.CODE)
    }
  }, [activePrimaryKey, pathname, setHomeProduct])
}
